import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_46d4tucq7t: FaireCollectionEntity = {
  token: "pbc_46d4tucq7t",
  type: "collection",
  name: "Spring/Summer In-Stock Favorites",
  heroImageUrl:
    "https://cdn.faire.com/fastly/873adaddda7a8d1f187a9a525ae8a8613cf4cef82cbc48ce10aa4a4de245feda.jpeg",
  itemCount: 67,
  description:
    "Stock up on these adorable spring-summer baby clothing favorites - always super soft, breathable and non-toxic, ethically made with small-farmer grown organic cotton in India. ",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:21.244Z",
    importedBy: "entity-db-import-collections",
  },
};
